import { render, staticRenderFns } from "./AdminPickupzonesTableRow.vue?vue&type=template&id=2d9d64a2&"
import script from "./AdminPickupzonesTableRow.vue?vue&type=script&lang=js&"
export * from "./AdminPickupzonesTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports